<template lang="pug">
.comments-list
  .comments-list__title
    | {{ title }}
  .comments-list__cards
    Card(v-for="comment in comments"
      :key="comment.id"
      :comment="comment"
      :course="course"
      :taskBlock="taskBlock"
      :choosen="choosen"
    )
</template>
<script>
import Card from './Card';
export default {
  components: {
    Card
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    comments: {
      type: Array,
      default: () => []
    },
    taskBlock: {},
    course: {},
    choosen: {}
  }
};
</script>
